import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Card, CardContent, CardMedia, Fab } from '@mui/material';
import { Palette as PaletteIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import URLManager from '../funcionalidadeNavbar/URLManager';
import PermissionGate from '../CadastroPerfilUsuario/PermissionGate';
import CatalogoVirtual from './CatalogoVirtual';

export default function QualidadeHome(){
  const _url = URLManager.getBaseURL();
  const [produtos, setProdutos] = useState([]);
  const [catalogoOpen, setCatalogoOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(()=>{
    let mounted = true;
    const fetchProdutos = async () => {
      try {
  const resp = await fetch(`${_url}/produto/pais`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
        if (!resp.ok) { if (mounted) setProdutos([]); return; }
        const list = await resp.json() || [];

        // coletar parent ids únicos para produtos que são filhos
        const parentIds = Array.from(new Set(list.filter(p => p.parentProductId).map(p => p.parentProductId)));

        // buscar dados dos pais em paralelo
        const parentsMap = {};
        if (parentIds.length) {
          await Promise.all(parentIds.map(async pid => {
            try {
              const r = await fetch(`${_url}/produto/${pid}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
              if (!r.ok) return;
              const jp = await r.json();
              parentsMap[pid] = jp;
            } catch (e) { /* ignore individual failures */ }
          }));
        }

        // montar lista de exibição: se item for filho, usar dados do pai para exibição e usar id do pai para navegação
        const display = list.map(p => {
          if (p.parentProductId && parentsMap[p.parentProductId]) {
            const parent = parentsMap[p.parentProductId];
            return {
              displayId: parent.idProduto || parent.id,
              nomeModelo: parent.nomeModelo || parent.nome || '',
              referencia: parent.referencia || parent.ref || '',
              image: parent.image || parent.imagem || null,
              originalId: p.idProduto
            };
          }
          return {
            displayId: p.idProduto,
            nomeModelo: p.nomeModelo || p.nome || '',
            referencia: p.referencia || p.ref || '',
            image: p.image || p.imagem || null,
            originalId: p.idProduto
          };
        });

        // deduplicate by displayId so parent appears only once
        const uniqueById = Object.values(display.reduce((acc, item) => {
          acc[item.displayId] = acc[item.displayId] || item;
          return acc;
        }, {}));

        if (mounted) setProdutos(uniqueById);
      } catch (e) {
        if (mounted) setProdutos([]);
      }
    };
    fetchProdutos();
    return () => { mounted = false; };
  },[_url]);

  return (
    <Box sx={{ padding: 3, position: 'relative' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        
        <Box>
          <PermissionGate permissions={["cadastrarTesteCalce"]}>
          <Typography variant="h5">Qualidade - Teste de Calce</Typography>
          <Typography variant="body2">Selecione um produto para cadastrar um teste de calce.</Typography>
          </PermissionGate>
        </Box>
        
        
        {/* Botão flutuante para abrir catálogo */}
        <Fab
          color="primary"
          variant="extended"
          onClick={() => setCatalogoOpen(true)}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1000,
            boxShadow: 3,
            '&:hover': {
              boxShadow: 6,
              transform: 'scale(1.05)'
            },
            transition: 'all 0.3s ease'
          }}
        >
          <PaletteIcon sx={{ mr: 1 }} />
          Catálogo Virtual
        </Fab>
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
        {produtos.map(p => (
          <Card key={p.displayId} sx={{ display: 'flex', flexDirection: 'column' }}>
            <CardMedia
              component="img"
              image={p.image ? (p.image.startsWith('http') ? p.image : `data:image/jpeg;base64,${p.image}`) : ''}
              alt={p.nomeModelo}
              sx={{ width: '100%', height: 140, objectFit: 'contain', background: '#fff', display: 'block' }}
            />
            <CardContent sx={{ flex: 1 }}>
              <Typography variant="subtitle1">{p.nomeModelo}</Typography>
              <Typography variant="caption" display="block">Ref: {p.referencia}</Typography>
              <Box sx={{ mt: 2 }}>
                <PermissionGate permissions={['cadastrarTesteCalce']}>
                  <Button variant="contained" size="small" onClick={() => navigate(`/qualidade/teste-calce/${p.displayId}`)}>Adicionar Teste</Button>
                </PermissionGate>
                <Button variant="outlined" size="small" sx={{ ml: 1 }} onClick={() => navigate(`/qualidade/dashboard?produtoId=${encodeURIComponent(p.displayId)}`)}>Ver Dashboard</Button>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* Modal do Catálogo Virtual */}
      <CatalogoVirtual
        open={catalogoOpen}
        onClose={() => setCatalogoOpen(false)}
      />
    </Box>
  );
}
